// Entry point for the build script in your package.json
/* intum application js v1.0.2 */

// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// import { appstorePaths } from 'src/config/rails-intum-paths'
import "./src/live_reload.js"
import "./src/activestorage.js"
import "./src/turbo_native/bridge"
import "./src/dark_mode"
import "./controllers"
import "./src/intum.js"
import "./src/axios_defaults.js"
import { Turbo } from "@hotwired/turbo-rails"
import Rails from "@rails/ujs"
// import './src/appstore/intum-appstore'
// import './src/insight/intum-insight'
// import './main/remove_attachments_handler'
// import './form/intum-forms-widget'
// import './kb/intum-helplinks-widget'
// import './main/fakturownia_edi'

Turbo.session.drive = false
Turbo.config.drive.progressBarDelay = 200
console.log("turbo aktywne:", Turbo)
Rails.start()

// console.log("IntumJs:", window.IntumJs)

// import { appstorePaths } from 'src/config/rails-intum-paths'
// import App from 'components/organize/OrganizeApp.vue'
// import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
// import "channels"
// import "./tailwind.css"

// Rails.start()
// Turbolinks.start()

console.log("intum application js v1.1.0")
